module.exports = __webpack_public_path__ + "img/bg01.6183b245.jpg";